import Vue from 'vue'
import Router from 'vue-router'
import config from '@/config'

// Import tratamento da meta
import { checkRequireAuth } from './meta/requireAuth'
// import { atualizaDashboard } from './meta/atualizaDashboard'
import { checkAcesso } from './meta/validaAcesso'

import auth from './modules/auth'
import home from './modules/default'

const routes = [
  ...auth,
  ...home,
  { path: '**', redirect: 'dashboard' }
]

function background (url) {
  let path = url.fullPath
  path = path.split('/')
  var element = null
  if (path[1] === 'auth') {
    element = document.getElementById('body')
    element.className = 'bodyLogin'
  } else {
    element = document.getElementById('body')
    element.className = ''
  }
}
// Vue use
Vue.use(Router)

// Cria router object
const options = {
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes
}
if (config.routerMode) options.mode = config.routerMode
const router = new Router(options)

// meta
router.beforeEach((to, from, next) => {
  checkRequireAuth(to, from, next)
  if (to.fullPath === '/dashboard' || to.fullPath === '/home' || to.fullPath === '/') {
    // atualizaDashboard()
  }
})

router.beforeResolve((to, from, next) => {
  checkAcesso(to, from, next)
})

router.afterEach((to) => {
  background(to)
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js